import { render } from "./Notification.vue?vue&type=template&id=085b3b0c&scoped=true&ts=true"
import script from "./Notification.vue?vue&type=script&lang=ts"
export * from "./Notification.vue?vue&type=script&lang=ts"

import "./Notification.vue?vue&type=style&index=0&id=085b3b0c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-085b3b0c"]])

export default __exports__